module.exports = __webpack_public_path__ + "img/vmwarevsphere-black.2f9d3f1d.svg";